var map = {
	"./logo_cn_invert_de.svg": 85790,
	"./logo_cn_invert_en.svg": 71782,
	"./logo_cn_invert_fr.svg": 89835,
	"./logo_cn_invert_nl.svg": 15861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51525;